import React from "react";
import { FirebaseAuth } from "react-firebaseui";
import firebaseui from "firebaseui";
import Typography from "material-ui/Typography";
import Paper from "material-ui/Paper";
import { withStyles } from "material-ui/styles";
import Divider from "material-ui/Divider";
import Helmet from "react-helmet";

import googleYoloManager from "../lib/googleYoloManager";
import firebase, { adminDatabase } from "../lib/firebase";

const styles = theme => ({
  root: theme.mixins.gutters({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "500px"
  }),
  errorMessageContainer: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3
  }),
  signInContainer: {
    marginTop: "5px"
  }
});

class WithAuthentication extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: firebase.auth().currentUser,
      needsManualSignIn: false,
      addYolo: false
    };
    this.authMetadataCallback = null;
    this.authMetadataRef = null;
    this.uiConfig = {
      signInFlow: "popup",
      signInSuccessUrl: "/admin",
      credentialHelper: firebaseui.auth
        ? firebaseui.auth.CredentialHelper.GOOGLE_YOLO
        : "",
      signInOptions: [
        firebaseui.auth ? firebase.auth.GoogleAuthProvider.PROVIDER_ID : ""
      ],
      callbacks: {
        signInSuccess: (currentUser, credential, redirectUrl) => false
      }
    };
  }

  componentDidMount() {
    this.unsubscribeAuthChangeListener = firebase
      .auth()
      .onAuthStateChanged(user => this.authChangeListener(user));
    googleYoloManager.addOnLoadListener();
    this.addYoloTimer = setTimeout(
      () => this.setState({ addYolo: true }),
      1000
    );
  }

  componentWillUnmount() {
    if (this.unsubscribeAuthChangeListener) {
      this.unsubscribeAuthChangeListener();
    }
    if (this.addYoloTimer) {
      this.addYoloTimer.clearTimeout();
      this.addYoloTimer = null;
    }
  }

  async authChangeListener(user) {
    if (this.authMetadataCallback) {
      this.authMetadataRef.off("value", this.authMetadataCallback);
    }
    if (user) {
      this.setState({ user });
      this.authMetadataRef = adminDatabase.ref(`accountInfo/${user.uid}`);
      this.authMetadataCallback = this.authMetadataRef.on("value", snapshot => {
        user.getIdToken(true);
      });
    } else {
      this.setState({ user: null });
      const signedIn = await googleYoloManager.login();
      this.setState({ needsManualSignIn: !signedIn });
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        {this.state.addYolo && (
          <Helmet>
            <script
              type="text/javascript"
              charSet="UTF-8"
              src="https://smartlock.google.com/client"
            />
          </Helmet>
        )}
        {this.state.user && this.props.children}
        {!this.state.user && (
          <div className={classes.root}>
            <Paper className={classes.errorMessageContainer} elevation={4}>
              <div>
                <Typography type="headline" component="h3">
                  You must be logged in to see this page
                </Typography>
                {this.state.needsManualSignIn && (
                  <div className={classes.signInContainer}>
                    <Divider />
                    <FirebaseAuth
                      uiConfig={this.uiConfig}
                      firebaseAuth={firebase.auth()}
                    />
                  </div>
                )}
              </div>
            </Paper>
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(WithAuthentication);



// WEBPACK FOOTER //
// ./src/components/WithAuthentication.js